import React, { useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";

const RecommSuccessPopup = ({ showPopup, setShowPopup, closePage }) => {

  const handleClose = () => {
    setShowPopup(false);
  }

  return (
    <>
      <Modal
        show={showPopup}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
        className="FormPop"
      >
        <Modal.Header closeButton>
          <Modal.Title>Success!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col lg="12" className="">
              <p>You can find your completed form on the 'Recommendations' tab.</p>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="FormbtnWrpper justify-content-end d-flex gap-10">
          <Button
            className="d-flex align-items-center justify-content-center commonBtn btnSm"
            onClick={closePage}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RecommSuccessPopup;
